import { render, staticRenderFns } from "./news_inner.vue?vue&type=template&id=79170929&scoped=true"
import script from "./news_inner.vue?vue&type=script&lang=js"
export * from "./news_inner.vue?vue&type=script&lang=js"
import style0 from "./news_inner.vue?vue&type=style&index=0&id=79170929&prod&lang=css"
import style1 from "./news_inner.vue?vue&type=style&index=1&id=79170929&prod&lang=css"
import style2 from "./news_inner.vue?vue&type=style&index=2&id=79170929&prod&scoped=true&lang=css"
import style3 from "./news_inner.vue?vue&type=style&index=3&id=79170929&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79170929",
  null
  
)

export default component.exports